import _ from "lodash";
import * as notify from "shared/notify";
import { formatForUse, newVariety } from "./lib/helper";

const unsetUpdated = (data) => {
    return Object.keys(data).reduce((obj, i) => {
        obj[i] = data[i];
        obj[i].isVarietyUpdated = false;
        obj[i].updatedUUIDs = null;

        return obj;
    }, {});
};

const reducer = (state, action) => {
    switch (action.type) {
        case "INIT":
            const initState = action.value && !_.isEmpty(action.value) ? formatForUse(action.value.items) : { ...newVariety(action.varietyName) };

            return {
                ...initState,
            };
        case "ADD_VARIETY":
            const addedVariety = newVariety(action.varietyName);

            return {
                ...unsetUpdated(state),
                ...addedVariety,
            };
        case "REMOVE_VARIETY":
            const removedVariety = Object.keys(state).reduce((obj, v) => {
                if (v !== action.varietyId) {
                    obj[v] = state[v];
                }

                if (state[v].childLinks.includes(action.varietyId)) {
                    obj[v] = { ...state[v], childLinks: state[v].childLinks.filter((c) => c !== action.varietyId) };
                }

                return obj;
            }, {});

            return {
                ...removedVariety,
            };
        case "UPDATE_VARIETY":
            const existingState = unsetUpdated(state);
            const previousLinkCode = state[action.varietyId].linkCode;
            const updatedVariety = { ...state[action.varietyId], [action.key]: action.value };

            if (action.key === "linkCode") {
                if (!action.value) {
                    // Remove Parents childLinks
                    if (previousLinkCode && existingState[previousLinkCode]) {
                        existingState[previousLinkCode].childLinks = existingState[previousLinkCode].childLinks.filter((l) => l !== action.varietyId);
                    }
                } else {
                    // Update Link reference for other state
                    Object.keys(existingState).forEach((key) => {
                        const hasChildLinks = existingState[key].childLinks.find((link) => link === action.varietyId);

                        // TODO: check if this is working as expected
                        // clear child link if variety has been changed e.g variety A => C = clear child links for variety A
                        if (hasChildLinks) {
                            existingState[key].childLinks = [];
                        }

                        if (existingState[key].code === action.value) {
                            existingState[key].childLinks = [...(existingState[key].childLinks || []), action.varietyId];
                        }
                    });
                }

                // Remove sharedValues anytime linkCode changes
                updatedVariety.sharedValues = [];
            }

            return {
                ...existingState,
                [action.varietyId]: updatedVariety,
            };
        case "UPDATE_VARIETY_ATTRIBUTE":
            const varietyUpdatedState = unsetUpdated(state);
            const isRemoveLink = action.fromLink && varietyUpdatedState[action.varietyId].sharedValues.includes(action.uuid);
            const varietyUpdatedAttribute = {
                ...varietyUpdatedState[action.varietyId],
                isVarietyUpdated: isRemoveLink ? false : true,
                updatedUUIDs: isRemoveLink ? null : [action.uuid],
            };

            // No Reason to update if we're removing a link
            if (!isRemoveLink) {
                varietyUpdatedAttribute.packAttributes[action.uuid] = action.fromLink
                    ? varietyUpdatedState[varietyUpdatedAttribute.linkCode].packAttributes[action.uuid]
                    : action.value;

                if (varietyUpdatedAttribute.childLinks) {
                    // Check child sharedValue and share for match
                    varietyUpdatedAttribute.childLinks.forEach((refKey) => {
                        if (varietyUpdatedState[refKey].sharedValues.includes(action.uuid)) {
                            varietyUpdatedState[refKey].packAttributes[action.uuid] = action.value;
                            varietyUpdatedState[refKey].isVarietyUpdated = true;
                            varietyUpdatedState[refKey].updatedUUIDs = [action.uuid];
                        }
                    });
                }
            }

            // Manage Shared Values
            if (action.fromLink) {
                if (isRemoveLink) {
                    //Remove Link
                    varietyUpdatedAttribute.sharedValues = varietyUpdatedAttribute.sharedValues.filter((l) => l !== action.uuid);
                } else {
                    //Add Link
                    varietyUpdatedAttribute.sharedValues = [...varietyUpdatedAttribute.sharedValues, action.uuid];
                }

                // Linked Attribute Warning
                if (action.linkedAttributes.length > 0) {
                    const alerts = action.linkedAttributes.reduce(
                        (arr, a) => {
                            //if (!varietyUpdatedAttribute.sharedValues.includes(a.uuid)) {
                            const text = !varietyUpdatedAttribute.sharedValues.includes(a.uuid)
                                ? `<b>${a.name} (Unlinked)</b>`
                                : `${a.name} (Linked)`;
                            arr.push(text);

                            //}
                            return arr;
                        },
                        ["This attribute is related to the following attributes and can cause syncing issues.<br />"]
                    );

                    notify.warning(alerts.join("<br />"));
                }
            }

            return {
                ...varietyUpdatedState,
                [action.varietyId]: varietyUpdatedAttribute,
            };
        case "REMOVE_VARIETY_ATTRIBUTE":
            const varietyRemovedState = unsetUpdated(state);

            const varietyRemovedAttribute = {
                ...varietyRemovedState[action.varietyId],
                isVarietyUpdated: true,
                updatedUUIDs: [action.uuid],
            };

            delete varietyRemovedAttribute.packAttributes[action.uuid];

            if (varietyRemovedAttribute.childLinks) {
                varietyRemovedAttribute.childLinks.forEach((refKey) => {
                    if (varietyRemovedState[refKey].sharedValues.includes(action.uuid)) {
                        delete varietyRemovedState[refKey].packAttributes[action.uuid];
                    }
                });
            }

            return {
                ...varietyRemovedState,
                [action.varietyId]: varietyRemovedAttribute,
            };
        default:
            return state;
    }
};

export { reducer };
